
/**
 * Helper
 */
var helper = require('../helper');

function UserFormController() {

    this.$changeableField = $('.js-changeable-field');
    this.$guardianElements = $('.js-changeableField-guardian');
    this.$clientContactElements = $('.js-changeableField-client-contact');
    this.$contractorContactElements = $('.js-changeableField-contractor-contact');

    // Numbers are role_id
    this.ContractorRoleId = 10;
    this.GuardianRoleId = 9;
    this.ClientRoleId = 8;

    this.$criminalRecordRadio = $('input[name=criminal_record]');
    this.$criminalRecordDescription = $('.js-criminal-record-description');
    this.$medicalConditionRadio = $('input[name=medical_condition]');
    this.$medicalConditionDescription = $('.js-medical-condition-description');

	this.$staffRadio = $('input[name=staff]');
	this.$staffFields = $('.js-staff-fields');

    var self = this; // Needed for using all constructor variables inside this function, note the difference -> no "this" but "var" at the beginning

    function setFieldsBasedOnRole($field) {

        switch (parseInt( $field.val()  )) {
            case self.GuardianRoleId:
                self.hideNotStandardFields();
                self.showGuardianFields();
                    // console.log('GUARDIAN');
                break;

            case self.ClientRoleId:
                self.hideNotStandardFields();
                self.showClientFields();
                    // console.log('CLIENT');
                break;

            case self.ContractorRoleId:
                self.hideNotStandardFields();
                self.showContractorFields();
                    // console.log('CONTRACTOR');
                break;

            default:
                self.hideNotStandardFields();
        }
    }

    function setInitFieldsBasedOnRole($field) { // We need to remember about validation!
        setFieldsBasedOnRole($field);
    }

    function setFieldsIfChecked($fieldToChange, $field){

      /**  console.log('change field checkbox');
        console.log($fieldToChange);
        console.log($fieldToChange.is(':checked'));*/

        if( $fieldToChange.is(':checked')){
            $field.show();
        }else{
            $field.hide();
        }

    }

    function setFieldsIfSelected($fieldToChange, $field){

        // console.log('change field radio');
        // console.log($fieldToChange);
        // console.log($fieldToChange.val());

        if( $fieldToChange.val() == 1 ){
            $field.show();
        }else{
            $field.hide();
        }

    }

    (function () {

        setInitFieldsBasedOnRole(self.$changeableField); // on init hide field which are not for standard user

        // Show / Hide fields depends on new value of changeable field
        self.$changeableField.change(function(){
            var $field = $(this);
            setFieldsBasedOnRole($field);
        });

    }());

    (function () {

        setFieldsIfSelected(self.$criminalRecordRadio.filter(':checked'), self.$criminalRecordDescription);

        self.$criminalRecordRadio.change(function(){
            var $this = $(this);

            setFieldsIfSelected($this, self.$criminalRecordDescription)
        });

    }());

    (function () {

        setFieldsIfSelected(self.$medicalConditionRadio.filter(':checked'), self.$medicalConditionDescription)

        self.$medicalConditionRadio.change(function(){
            var $this = $(this);

            setFieldsIfSelected($this, self.$medicalConditionDescription)
        });

    }());

	(function () {

		setFieldsIfSelected(self.$staffRadio.filter(':checked'), self.$staffFields)

		self.$staffRadio.change(function(){
			var $this = $(this);

			setFieldsIfSelected($this, self.$staffFields)
		});

	}());

}

UserFormController.prototype.hideNotStandardFields = function() {

    this.$guardianElements.each(function(){
        $(this).hide();
    });

    this.$clientContactElements.each(function(){
        $(this).hide();
    });

    this.$contractorContactElements.each(function(){
        $(this).hide();
    });

}

UserFormController.prototype.showGuardianFields = function() {

    this.$guardianElements.each(function(){
        $(this).show();
    });

    this.$criminalRecordDescription.show();
    this.$medicalConditionDescription.show();

}

UserFormController.prototype.showContractorFields = function() {

    this.$contractorContactElements.each(function(){
        $(this).show();
    });
}

UserFormController.prototype.showClientFields = function() {

    this.$clientContactElements.each(function(){
        $(this).show();
    });
}

module.exports = UserFormController;
